export default __webpack_public_path__ + "static/media/paso15.54963aef.png";